var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgServerless = function SvgServerless(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4f71145-bdde-4480-81c2-e23ae1a4ee5e",
    "data-name": "bac47946-aaa5-43b2-bbcb-76ec2ac9bb1d",
    viewBox: "0 0 243.1 386.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M344,129.3v67.2c-5-2.5-6.4,2.6-8.6,4.7q-65.5,58.4-130.6,117.1l-76,68.2c0-23.6.2-44-.2-64.4a31.6,31.6,0,0,1,5-18c15.2-24.8,29.9-50,45.6-76.4-27.3,2.8-52.4,10.1-78.3,10.2V196.5c7.6-1.5,11.4-8.1,16.7-12.6Q219.3,97.4,320.5,10.3c3.2-2.7,9.7-3.6,8-10.3h5.2c14.8,49.9-3.9,91.8-35.2,131.5C316,132.7,329.8,127.4,344,129.3ZM141.8,356.1c2.9-1.4,3.8-1.6,4.4-2.2L324.7,193c2.5-2.2,5.4-4.3,5.4-8.3-.1-11,0-22.1,0-34.3-3.2,1.3-4.6,1.5-5.4,2.3L146.5,313.8c-3.1,2.8-4.7,5.8-4.7,10C141.9,334.1,141.8,344.3,141.8,356.1Zm65.1-172.7-43,6.2c-11.8,1.7-23.7,3.6-35.5,5.6-14.2,2.4-10.9,13.5-10.4,22.3.6,11,9.1,4.8,13.7,4.4,12.3-1.2,24.5-5.3,36.8-5.3,22.6,0,30.1-15.5,38.4-33.2ZM323.5,34.9l-65,104.3c14.1,1.1,24.2-.6,30.8-14a333.9,333.9,0,0,1,26.4-44.1C325.2,67.6,324.8,53.5,323.5,34.9Z",
    transform: "translate(-100.9 0)",
    style: {
      fill: "#183149"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServerless, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/serverless.ae6a303c.svg";
export { ForwardRef as ReactComponent };